import { render } from "./OrderTraceDialog.vue?vue&type=template&id=6a18d692&scoped=true&ts=true"
import script from "./OrderTraceDialog.vue?vue&type=script&lang=ts"
export * from "./OrderTraceDialog.vue?vue&type=script&lang=ts"

import "./OrderTraceDialog.vue?vue&type=style&index=0&id=6a18d692&lang=less&scoped=true"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a18d692"]])

export default __exports__